import { ISelectOptions } from '~/Models/interfaces/SelectOption.models';
import { IOutlinedTextFieldProps, ITextFieldProps } from '~/UIKit';
import { ItemCreationToolTipProps } from './ItemCreationToolTip';

export enum ItemCreationValidInput {
  NUMBER,
  TEXT,
  MONEY,
  DATE,
  TIME,
  SELECT,
  PERIOD,
  LIMITED_PERIOD,
  CHECKBOX,
  COLOR,
  TRAINER_SELECTOR,
  LOCATION_SELECTOR,
  BOOKINGGROUP_SELECTOR,
  SWITCHER,
  COUNTER,
  LOCATION_SELECTOR_MULTI,
}

export interface IItemCreationSubsectionInputOneValue<T> {
  name: keyof T;
  label: string | JSX.Element;
  key?: string | number;
  placeholder?: string;
  type:
    | ItemCreationValidInput.TEXT
    | ItemCreationValidInput.NUMBER
    | ItemCreationValidInput.COLOR
    | ItemCreationValidInput.DATE
    | ItemCreationValidInput.TIME
    | ItemCreationValidInput.TRAINER_SELECTOR
    | ItemCreationValidInput.LOCATION_SELECTOR
    | ItemCreationValidInput.BOOKINGGROUP_SELECTOR
    | ItemCreationValidInput.SWITCHER
    | ItemCreationValidInput.COUNTER
    | ItemCreationValidInput.LOCATION_SELECTOR_MULTI;
  icon?: JSX.Element;
  InputProps?: ITextFieldProps | IOutlinedTextFieldProps;
  disabled?: boolean;
  children?: IItemCreationSubsectionInputProps<T>[];
  noIconBackground?: boolean;
  hasAnError?: boolean;
  displayManipulation?: (value: any) => any;
  secondaryValueDisplayManipulation?: (value: any) => any;
  hidden?: boolean;
  isAChild?: boolean;
  secondaryName?: undefined;
  secondaryDisabled?: undefined;
  secondaryPlaceholder?: undefined;
  options?: undefined;
  customElement?: undefined;
  customElementFullSection?: undefined;
  tooltip?: Omit<ItemCreationToolTipProps, 'containerRef'> | false;
  noBorder?: boolean;
  showErrorLabel?: boolean;
  isEdit?: boolean;
  note?: JSX.Element;
}
export interface IItemCreationSubsectionInputMultiValue<T> {
  name: keyof T;
  label: string | JSX.Element;
  placeholder?: string;
  type:
    | ItemCreationValidInput.MONEY
    | ItemCreationValidInput.PERIOD
    | ItemCreationValidInput.LIMITED_PERIOD;
  icon?: JSX.Element;
  InputProps?: ITextFieldProps | IOutlinedTextFieldProps;
  disabled?: boolean;
  secondaryName: keyof T;
  secondaryDisabled?: boolean;
  secondaryPlaceholder?: string;
  children?: IItemCreationSubsectionInputProps<T>[];
  noIconBackground?: boolean;
  hasAnError?: boolean;
  displayManipulation?: (value: any) => any;
  secondaryValueDisplayManipulation?: (value: any) => any;
  hidden?: boolean;
  isAChild?: boolean;
  options?: undefined;
  customElement?: undefined;
  customElementFullSection?: undefined;
  tooltip?: Omit<ItemCreationToolTipProps, 'containerRef'> | false;
  noBorder?: boolean;
  showErrorLabel?: boolean;
  isEdit?: boolean;
  note?: JSX.Element;
}
export interface IItemCreationSubsectionInputSelect<T> {
  name: keyof T;
  label: string | JSX.Element;
  placeholder?: string;
  type: ItemCreationValidInput.SELECT;
  icon?: JSX.Element;
  InputProps?: ITextFieldProps | IOutlinedTextFieldProps;
  options: ISelectOptions;
  disabled?: boolean;
  children?: IItemCreationSubsectionInputProps<T>[];
  noIconBackground?: boolean;
  hasAnError?: boolean;
  displayManipulation?: (value: any) => any;
  secondaryValueDisplayManipulation?: (value: any) => any;
  hidden?: boolean;
  isAChild?: boolean;
  secondaryName?: undefined;
  secondaryDisabled?: undefined;
  secondaryPlaceholder?: undefined;
  customElement?: undefined;
  customElementFullSection?: undefined;
  tooltip?: Omit<ItemCreationToolTipProps, 'containerRef'> | false;
  noBorder?: boolean;
  showErrorLabel?: boolean;
  isEdit?: boolean;
  note?: JSX.Element;
}

export type IItemCreationInputProps<T> =
  | IItemCreationSubsectionInputOneValue<T>
  | IItemCreationSubsectionInputMultiValue<T>
  | IItemCreationSubsectionInputSelect<T>;

interface IItemCreationInputCustom {
  customElement: JSX.Element;
  customElementFullSection?: boolean;
  hidden?: boolean;
  name?: string;
  label?: undefined;
  placeholder?: undefined;
  type?: undefined;
  icon?: undefined;
  InputProps?: undefined;
  disabled?: undefined;
  secondaryName?: undefined;
  secondaryDisabled?: undefined;
  secondaryPlaceholder?: undefined;
  children?: undefined;
  noIconBackground?: undefined;
  options?: undefined;
  hasAnError?: undefined;
  displayManipulation?: undefined;
  secondaryValueDisplayManipulation?: undefined;
  isAChild?: undefined;
  tooltip?: Omit<ItemCreationToolTipProps, 'containerRef'> | false;
  noBorder?: boolean;
  showErrorLabel?: boolean;
  isEdit?: boolean;
  note?: JSX.Element;
}

export interface IItemCreationSubsectionInputExtraProps {
  isAChild?: boolean;
}

export type IItemCreationSubsectionInputProps<T> =
  | IItemCreationInputCustom
  | IItemCreationInputProps<T>;
